import React, { memo, useCallback } from 'react';

import Button from 'react-bootstrap/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

/**
 * Chip list of selected device FCM tokens + "Add tokens" button (opens AddTokensBox).
 *
 * Props
 *   tokens:          string[] — current chosen device tokens (compacted by parent)
 *   onDeleteToken:   (idx: number, tokens: string[]) => void
 *   onShowAddBox:    () => void
 */
const DeviceTokensList = ({ tokens, onDeleteToken, onShowAddBox }) => {
  const handleDelete = useCallback(
    (idx) => onDeleteToken(idx, tokens),
    [onDeleteToken, tokens]
  );

  return (
    <div className='device-tokens-box'>
      <div className='tokens-box'>
        {tokens.map((token, idx) => (
          <div className='md-chip' key={idx}>
            <span>{token}</span>
            <span className='fill-remaining-space' />
            <Button
              variant='link'
              className='md-chip-remove'
              onClick={() => handleDelete(idx)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
        ))}
      </div>
      <button
        type='button'
        className='add-more-token-button'
        onClick={onShowAddBox}
        aria-label='Add device tokens'
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  );
};

export default memo(DeviceTokensList);
